let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7Q86P")).then(() => parcelRequire('1Aw1f'));